// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__ERpUT","title":"InfoRow_title__1PA0n"};